"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderWithRouter = void 0;
var _reactRouterDom = require("react-router-dom");
var _pure = require("@testing-library/react/dist/pure");
var _userEvent = _interopRequireDefault(require("@testing-library/user-event"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Method to render components for testing, wrapped in a Browser Router
 *
 * @name mockUseTheme
 * @param {node} obj Child component to render
 * @returns {object} Router configuration properties
 */
const renderWithRouter = function (ui) {
  let {
    route = "/"
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.history.pushState({}, "Test page", route);
  return {
    user: _userEvent.default.setup(),
    ...(0, _pure.render)(ui, {
      wrapper: _reactRouterDom.BrowserRouter
    })
  };
};
exports.renderWithRouter = renderWithRouter;